import React from "react";
import { Outlet } from "react-router-dom";
import GlobalStatusBar from "../components/GlobalStatusBar";
import Header from "../components/Header";
import TopNav from "../components/TopNav";
import MasqueradeBanner from "../components/MasqueradeBanner";
import { useAuth } from "../context/AuthContext";

export default function AppShell() {
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-background">
      <MasqueradeBanner />
      <GlobalStatusBar />
      <Header user={user} />
      <TopNav />
      <main className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-8 py-6">
        <Outlet />
      </main>
      <footer className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-8 py-8 text-[12px] text-muted-foreground">
        UC Vigil v1.0 — Internal staff console
      </footer>
    </div>
  );
}
